module.exports = __webpack_public_path__ + "static/media/calzadoHombre.a4d7aa46.png";